import { withChartLayout } from 'components/common';
import SavedBasicNursingCare from 'components/features/chart/basic-nursing-care/saved-basic-nursing-care/SavedBasicNursingCare';

const SavedBasicNursingCarePage = withChartLayout('Saved Basic Nursing Care')(SavedBasicNursingCare);
export default SavedBasicNursingCarePage;
